<template>
  <div class="index">
    <div
      class="index-header"
      :class="$route.path !== '/insure' ? '' : 'header'"
    >
      <div class="header_logo">
        <div class="img_logo">
          您好，欢迎您来到甘肃省担保集团电子保函服务平台
        </div>
        <div
          v-if="['/insure', '/payment', '/payInfo'].includes($route.path)"
          class="logo_right"
        >
          <div class="info">
            客服电话
          </div>
          <div class="phone">
            <div>0931-8808811</div>
          </div>
        </div>
        <div
          class="head-munu"
          v-if="!['/insure', '/payment', '/payInfo'].includes($route.path)"
        >
          <a-menu :selected-keys="[$route.path]" mode="horizontal">
            <a-menu-item :key="'/'">
              <router-link to="/">
                <span class="router-link">首页</span>
              </router-link>
            </a-menu-item>
            <a-sub-menu>
              <span slot="title" class="submenu-title-wrapper">保函业务</span>
              <a-menu-item :key="'/bidSecurity'">
                <router-link to="bidSecurity">
                  <span>投保保函</span>
                </router-link>
              </a-menu-item>
              <a-menu-item :key="'/performStep'">
                <router-link to="performStep">
                  <span>履约保函</span>
                </router-link>
              </a-menu-item>
              <a-menu-item :key="'/advanceCharge'">
                <router-link to="advanceCharge">
                  <span>预付款保函</span>
                </router-link>
              </a-menu-item>
              <a-menu-item :key="'/quality'">
                <router-link to="quality">
                  <span>质量保函</span>
                </router-link>
              </a-menu-item>
              <a-menu-item :key="'/migrantWorkers'">
                <router-link to="migrantWorkers">
                  <span>农民工工资保函</span>
                </router-link>
              </a-menu-item>
            </a-sub-menu>
            <a-menu-item :key="'/guaranteeTruth'">
              <router-link to="guaranteeTruth">
                <span class="router-link">保函验真</span>
              </router-link>
            </a-menu-item>
            <a-menu-item :key="'/brandintroduction'">
              <router-link to="brandintroduction">
                <span class="router-link">关于我们</span>
              </router-link>
            </a-menu-item>
            <a-menu-item :key="'/orderCenter'">
              <router-link to="orderCenter">
                <span class="router-link">账户中心</span>
              </router-link>
            </a-menu-item>
          </a-menu>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped>
.index {
}
.header {
  justify-content: flex-start !important;
}
.index-header {
  height: 105px;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  // padding: 0 140px;
  .head-welcome {
    color: #999999;
    min-width: 200px;
  }
  .header_logo {
    width: 1200px;
    height: 100%;
    margin: auto;
    display: flex;
    justify-content: space-between;
    padding-top: 40px;
    .img_logo {
      // width: 401px;
      // height: 53px;
    }
    .logo_right {
      display: flex;
    }
    .info {
      height: 100%;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      padding-top: 3px;
      margin-right: 10px;
    }
    .phone {
      font-size: 24px;
      font-family: DIN Medium-Regular, DIN Medium;
      font-weight: 400;
      color: #005ca8;
      line-height: 28px;
    }
  }
  .head-munu {
    // margin-left: 300px;
  }
}
::v-deep .ant-menu-horizontal {
  border-bottom: none !important;
  font-size: 18px;
}
::v-deep .ant-menu-item,
.ant-menu-submenu-title {
  font-size: 18px;
}
::v-deep .ant-menu-horizontal > .ant-menu-item,
.ant-menu-horizontal > .ant-menu-submenu {
  top: 0px !important;
  border-bottom: none !important;
}
::v-deep .ant-menu-submenu-selected,
.ant-menu-horizontal > .ant-menu-item-selected > a {
  color: #2e4e9a !important;
  font-weight: 600;
}
::v-deep .ant-menu-submenu-title:hover,
.ant-menu-item-active > a,
.ant-menu-submenu-open .ant-menu-submenu-title .submenu-title-wrapper {
  color: #2e4e9a !important;
}
</style>
